<template>
  <v-container
    :key="nKey"
    v-if="oPermisos.priv_access == '1'"
    grid-list-xs
    class="pa-0 ma-0"
    fluid
  >
    <v-row class="pa-0 ma-0 titlesdark--text mb-3">
      <v-col md="8" sm="12" class="pa-0 ma-0 mt-1">
        <span class="pl-1 text-light font-size-2">{{ sTituloGrid }}</span>
      </v-col>
    </v-row>
    <v-row class="no-gutters" v-show="bCargandoCampos">
      <v-col cols="12">
        <v-skeleton-loader
          type="table-heading, list-item-three-line"
        ></v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row class="no-gutters" v-show="!bCargandoCampos">
      <v-container fluid>
        <v-row class="no-gutters">
          <v-container class="cont-shadown-rounded back-white pa-1" fluid>
            <v-row class="no-gutters">
              <v-col
                sm="12"
                cols="12"
                :md="oItem.cols"
                :lg="oItem.cols"
                :xl="oItem.cols"
                class="pa-1"
                v-for="(oItem, idx) in aFormItems"
                :key="'oItem-' + idx"
              >
                <component
                  v-model="oRegistro[oItem.nombre]"
                  v-show="oItem.Visible === '1' ? true : false"
                  :ref="`form-${oItem.nombre}`"
                  :is="oItem.tipo"
                  :titulo="oItem.label"
                  :obligatorio="oItem.obligatorio == '1' ? true : false"
                  :condicion="oItem.Condicion"
                  :inner="oItem.innerJoin"
                  :campo="oItem.nombre"
                  :editable="oItem.editable"
                  :campoFiltro="oItem.CampoFiltro"
                  :valorFiltro="oItem.ValorFiltro"
                  :sCampoModificaA="oItem.ModificaA"
                  :sTabla="sTabla"
                  @ModificaA="onModificarCampo"
                >
                </component>
              </v-col>
              <v-col sm="12" cols="12" class="py-0 ma-0">
                <FormTexto
                  v-model="oRegistro.sCorreos"
                  :titulo="'Correos'"
                  :editable="'1'"
                  :sTooltip="'Ej: correo1@correo.com;correo2@correo.com'"
                  :sPlaceHolder="'Ingresa los correos. Recuerda que deben separarse por ; y sin espacios'"
                  :obligatorio="false"
                >
                </FormTexto>
              </v-col>
              <!-- CAMPO DE AÑADIR  CONTACTOS-->
              <v-col sm="12" cols="12" class="py-0 ma-0 mt-2">
                <span class="titleslight--text"
                  >{{
                    $store.state.jsIdioma.oEquivalencias.ttlContactos
                  }}*</span
                >
                <v-col
                  sm="12"
                  cols="12"
                  class="pa-2 ma-0 under-sec-nomargin d-flex align-center justify-end"
                >
                  <p
                    color="primary"
                    class="titleslight--text font-weight-medium pa-0 ma-0"
                  >
                    {{
                      $store.state.jsIdioma.oEquivalencias.sttlAgregarContactos
                    }}
                  </p>
                  <v-btn
                    color="primary"
                    elevation="2"
                    fab
                    small
                    @click="bMostrarContactos = true"
                    class="ml-3"
                  >
                    <v-icon size="35">mdi-plus</v-icon>
                  </v-btn>
                </v-col>
                <v-row class="no-gutters">
                  <v-col
                    sm="6"
                    cols="12"
                    class="pa-0 ma-0"
                    v-for="(oRow, nKey) in oRegistro.aContactos"
                    :key="nKey"
                  >
                    <v-card class="border-card px-2 my-1 mx-1">
                      <v-card-text class="ma-0 pa-1">
                        <v-row class="ma-0 pa-0">
                          <v-col
                            sm="12"
                            cols="12"
                            class="pa-0 ma-0 titlesdark--text d-flex"
                          >
                            <span class="text-medium"
                              >{{
                                $store.state.jsIdioma.oEquivalencias.lblNombre
                              }}:</span
                            >
                            <span class="ml-2">{{ oRow.sNombre }}</span>
                            <v-btn
                              class="ml-auto"
                              icon
                              color="primary"
                              @click="onEliminarContacto(nKey)"
                            >
                              <v-icon>fa-solid fa-trash</v-icon>
                            </v-btn>
                          </v-col>
                          <v-col
                            sm="12"
                            cols="12"
                            class="pa-0 ma-0 ColumnaResumida titlesdark--text d-flex"
                          >
                            <span class="text-medium">{{
                              $store.state.jsIdioma.oEquivalencias.cmpCorreo
                            }}</span>
                            <span class="ml-2">{{ oRow.sCorreo }}</span>
                          </v-col>
                          <v-col
                            sm="12"
                            cols="12"
                            class="pa-0 ma-0 ColumnaResumida titlesdark--text d-flex"
                          >
                            <span class="text-medium"
                              >{{
                                $store.state.jsIdioma.oEquivalencias
                                  .cmpTelefono
                              }}:</span
                            >
                            <span class="ml-2">{{ oRow.sTelefono }}</span>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="my-2">
                <v-divider></v-divider>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
        <v-row class="no-gutters pa-2 mb-2">
          <div class="mx-auto">
            <v-btn color="btncolor" dark class="mx-1" @click="onCancelar"
              >{{ $store.state.jsIdioma.oEquivalencias.btnCancelar }}
            </v-btn>
            <v-btn
              color="btncolor"
              dark
              class="mx-1"
              @click="onGuardarRegistro"
              :loading="bCargando"
              :class="{ 'btn-disabled': bCargando }"
              >{{ $store.state.jsIdioma.oEquivalencias.btnGuardar }}
            </v-btn>
          </div>
        </v-row>
      </v-container>
      <ModalMensajeGeneral
        v-model="oModalMensaje.bModalVisible"
        :sMensaje="oModalMensaje.sMensaje"
        :nTipo="oModalMensaje.nTipo"
      />
    </v-row>
    <v-dialog
      v-model="bMostrarContactos"
      persistent
      max-width="400px"
      :key="nKeyModalContactos"
    >
      <v-card>
        <v-toolbar color="headformsdark" height="45" elevation="0" dense dark>
          <v-spacer></v-spacer>
          <span class="mdlHeadForms">{{
            $store.state.jsIdioma.oEquivalencias.lblAgregarAsistentes
          }}</span>
          <v-spacer></v-spacer>
          <v-btn
            color="btncolor-dark"
            @click="onResetVistaContactos"
            icon
            small
            dark
            outlined
          >
            <v-icon size="14px">fa fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container class="mt-2">
          <v-row>
            <v-col sm="12" cols="12" class="py-0 ma-0 ColumnaResumida">
              <FormTexto
                v-model="oContacto.sNombre"
                :titulo="'Nombre Contacto'"
                :editable="'1'"
                :obligatorio="true"
              >
              </FormTexto>
            </v-col>
            <v-col sm="12" cols="12" class="py-0 ma-0 ColumnaResumida">
              <FormCorreo
                v-model="oContacto.sCorreo"
                :titulo="'Correo'"
                :editable="'1'"
                :obligatorio="true"
              >
              </FormCorreo>
            </v-col>
            <v-col sm="12" cols="12" class="py-0 ma-0 ColumnaResumida">
              <FormNumero
                v-model="oContacto.sTelefono"
                :titulo="'Telefono'"
                :editable="'1'"
                :obligatorio="true"
              >
              </FormNumero>
            </v-col>
            <v-col cols="12" class="py-0 ma-0 mb-3">
              <div class="d-flex justify-center align-center my-2">
                <v-btn
                  class="btn-rounded d-flex mx-2"
                  depressed
                  light
                  outlined
                  color="buttondark"
                  @click="onAgregarContacto"
                  >{{ $store.state.jsIdioma.oEquivalencias.btnAgregar }}
                </v-btn>
                <v-btn
                  class="btn-rounded d-flex mx-2"
                  depressed
                  light
                  outlined
                  color="buttondark"
                  @click="onResetVistaContactos"
                  >{{ $store.state.jsIdioma.oEquivalencias.btnCancelar }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <ErrorView v-model="bMostrarErrores" :aErrores="aErrores"></ErrorView>
    <modal-mensaje-general
      v-model="oModalMensajeInput.bModalMensaje"
      :sMensaje="oModalMensajeInput.sMensaje"
      :nTipo="oModalMensajeInput.nTipo"
      :sNombreBotonConfirmar="oModalMensajeInput.sNombreBotonConfirmar"
      @respuesta="onRespuestaModal"
    />
    <v-dialog
      v-model="bCargandoEstado"
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card height="100%">
        <v-card-text class="contlist ma-0 pa-1">
          <div
            class="mx-auto d-flex justify-center align-center pa-2 tit-cargando"
          >
            <fulfilling-square-spinner
              :animation-duration="4000"
              :size="40"
              color="#0E69B0"
            />
            <h2 class="ma-0 ml-4 text-medium text-primary">Guardando...</h2>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>

  <div class="no-acceso" v-else-if="!bCargando && oPermisos.priv_access == '0'">
    <v-sheet color="dark" class="cont-tabla">
      <v-skeleton-loader
        :loading="false"
        class="mx-auto"
        max-width="100%"
        type="table-heading, table-thead, table-tbody, table-tfoot"
      >
      </v-skeleton-loader>
      <div class="mensaje">
        <div class="cont-icon">
          <v-icon size="40px" class="icon">mdi-lock-off-outline</v-icon>
        </div>
        <div class="texto-mensaje pa-3">
          <span class="text-primary font-size-1">
            {{ $store.state.jsIdioma.oEquivalencias.msgSinPermisosApp }}
          </span>
        </div>
      </div>
    </v-sheet>
  </div>
</template>
  <script>
import selector from "@/components/Form/Componentes/FormSelect.vue";
import formlabel from "@/components/Form/Componentes/FormLabel.vue";
import numero from "@/components/Form/Componentes/FormNumero.vue";
import selectordependiente from "@/components/Form/Componentes/FormSelectFiltro.vue";
import FormMultiSelect from "@/components/Form/Componentes/FormMultiSelect.vue";
import FormTextArea from "@/components/Form/Componentes/FormTextArea.vue";
import FormTabla from "@/components/Form/Componentes/FormTabla.vue";
import FormMultipleRadioButton from "@/components/Form/Componentes/FormMultipleRadioButton.vue";
import axiosServices from "@/services/axiosServices.js";

import texto from "@/components/Form/Componentes/FormTexto.vue";
import textArea from "@/components/Form/Componentes/FormTextArea.vue";
import mxFunciones from "@/mixins/funciones.js";
import FormArchivos from "@/components/Form/Componentes/FormArchivos.vue";
import FormTexto from "@/components/Form/Componentes/FormTexto.vue";
import FormCorreo from "@/components/Form/Componentes/FormCorreo.vue";
import FormNumero from "@/components/Form/Componentes/FormNumero.vue";
import ErrorView from "@/components/ErrorView.vue";
// utils
import jsFecha from "@/Utlidades/Hora_Fecha.js";
import jsFormulario from "@/Utlidades/FormularioUtils.js";

import { FulfillingSquareSpinner } from "epic-spinners";
export default {
  name: "FormNuevoPqr",
  components: {
    selector,
    numero,
    selectordependiente,
    FormMultiSelect,
    FormMultipleRadioButton,
    FormTextArea,
    FormTabla,
    formlabel,
    texto,
    textArea,
    FormArchivos,
    FormTexto,
    FormCorreo,
    FormNumero,
    ErrorView,
    FulfillingSquareSpinner,
  },
  mixins: [mxFunciones],
  data() {
    return this.onIniciarData();
  },
  async mounted() {
    this.onIniciarVista();
  },
  methods: {
    onIniciarData() {
      return {
        bCargandoEstado: false,
        oModalMensaje: {
          bModalVisible: false,
          sMensaje: "",
          nTipo: 2,
        },
        oRegistro: {
          aContactos: [],
        },
        aFormItems: [],
        bCargando: false, // Esta de carga de información
        bCargandoCampos: true, // Cargando formularios
        sTituloGrid: "",
        sTabla: "PQR_Requerimientos",
        aPermisosPQR: [],
        sIdDinamico: "",
        bPermisoDinamico: false,
        aAnexosSubir: [],
        nKey: 0,
        bMostrarContactos: false,
        nKeyModalContactos: 0,
        oContacto: {},
        bMostrarErrores: false,
        aErrores: [],
        nKeyActual: -1,
        oModalMensajeInput: {
          bModalMensaje: false,
          sMensaje: "",
          nTipo: 1,
          sNombreBotonConfirmar: "Eliminar",
        },
      };
    },
    async onIniciarVista() {
      this.sTituloGrid = await this.getTitulo(this.sTabla);
      this.onCargarCampos();
    },
    onResetVistaContactos() {
      this.bMostrarContactos = false;
      this.oContacto = {};
    },
    onEliminarContacto(nKey) {
      this.nKeyActual = nKey;
      this.oModalMensajeInput.bModalMensaje = true;
      this.oModalMensajeInput.sMensaje =
        "¿Estás seguro de eliminar el contacto?";
    },
    onRespuestaModal(bRespuesta) {
      this.oModalMensajeInput.bModalMensaje = false;
      if (bRespuesta) {
        this.oRegistro.aContactos.splice(this.nKeyActual, 1);
        this.nKeyActual = -1;
      }
    },
    onAgregarContacto() {
      this.validarCamposContacto();

      // Valido que bMostrarErrores siga en falso
      if (this.bMostrarErrores) return;

      this.oRegistro.aContactos.push(this.oContacto);
      this.oModalMensaje = {
        bModalMensaje: false,
        sMensaje: "Contacto Agregado",
        nTipo: 1,
      };
      this.onResetVistaContactos();
    },
    validarCamposContacto() {
      this.aErrores = [];
      this.bMostrarErrores = false;
      if (!Object.prototype.hasOwnProperty.call(this.oContacto, "sNombre")) {
        this.aErrores.push("Debe diligenciar el nombre del contacto");
      } else {
        if (this.oContacto.sNombre === "" || this.oContacto.sNombre === null)
          this.aErrores.push("Debe diligenciar el nombre del contacto");
      }

      if (!Object.prototype.hasOwnProperty.call(this.oContacto, "sCorreo")) {
        this.aErrores.push("Debe diligenciar el correo");
      } else {
        if (this.oContacto.sCorreo === "" || this.oContacto.sCorreo === null)
          this.aErrores.push("Debe diligenciar el correo");

        this.oContacto.sCorreo.split(";").forEach((item) => {
          const emailRegex =
            /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
          if (!emailRegex.test(item)) {
            this.aErrores.push("Correo inválido");
          }
        });
      }

      if (!Object.prototype.hasOwnProperty.call(this.oContacto, "sTelefono")) {
        this.aErrores.push("Debe diligenciar el telefono");
      } else {
        if (
          this.oContacto.sTelefono === "" ||
          this.oContacto.sTelefono === null
        )
          this.aErrores.push("Debe diligenciar el telefono");
      }

      this.bMostrarErrores = this.aErrores.length > 0;
    },
    async onCargarCampos() {
      this.bCargandoCampos = true;
      this.bCargando = true;
      let sParams = "sTable=" + this.sTabla;
      const aPermisos = await axiosServices.getConfiguration(
        "/pqr/permisos",
        true,
        sParams
      );
      this.aPermisosPQR = aPermisos.aData;

      const aCampos = await axiosServices.getConfiguration(
        "/formulario_campos",
        true,
        sParams
      );
      this.aFormItems = aCampos.aData;

      this.aFormItems.forEach((oItem) => {
        if ( oItem.Visible === "0" && oItem.Condicion !== "" && oItem.tipo === "texto") {
          const rex = /&&\w+&&/gi;
          if (oItem.Condicion.match(rex).length > 0) {
            this.oRegistro[oItem.nombre] = Object.prototype.hasOwnProperty.call(
              this.$store.state,
              oItem.Condicion.replaceAll("&&", "")
            )
              ? this.$store.state[oItem.Condicion.replaceAll("&&", "")]
              : oItem.Condicion;
            }
        } else {
          this.oRegistro[oItem.nombre] = oItem.Condicion;
        }
      });
      this.bCargandoCampos = false;
      this.bCargando = false;
    },
    onCancelar(sMensaje = "") {
      this.$nextTick(() => {
        // Add the component back in
        Object.assign(this.$data, this.onIniciarData());
        this.oModalMensaje.sMensaje = sMensaje;
        this.nKey++;
        this.onIniciarVista();
      });
    },
    onLimpiarDataFormulario() {
      this.aFormItems.forEach((elemento) => (elemento.Valor = ""));
    },
    async onModificarCampo(sCampoModificado, sValor) {
        var nIndex = this.aFormItems.findIndex(
            (oItem) => oItem.nombre === sCampoModificado
        );

      //validar si se necesita traer la ciudad
      if(sValor!=undefined && 'NombreCiudad'==sCampoModificado){
        const { aData, sStatus } = await axiosServices.getConfiguration(
          "/select_filtroCiudadSede/"+sValor,
          true,
        );
        if(sStatus=='success'&& aData.length==1){
          this.oRegistro[this.aFormItems[nIndex].nombre] = await aData[0].id;
          this.$forceUpdate();
        }
      }
      else{
        let nSuma = 0;
        
        for (let index = 0; index < this.aFormItems.length; index++) {
          if(this.aFormItems[index].nombre === sCampoModificado) {
            nSuma = index;
          }          
        }
        // aqui en particular debemos tomar el ultimo sCampomodificado debido a que en db se repiten el campo filtro nombre
        if(nSuma > 1) {
          nIndex = nSuma;
        }

        if (this.aFormItems[nIndex].tipo === "selectordependiente") {
            this.aFormItems[nIndex].ValorFiltro = sValor;
            this.$forceUpdate();
        } else {
          this.oRegistro[this.aFormItems[nIndex].nombre] = sValor;
        }
      }
    },
    async onGuardarRegistro() {
      this.aErrores = [];
      this.bCargando = true;
      this.bCargandoEstado = true;
      const oValidacion = jsFormulario.onValidarCamposObligatorios(
        this.aFormItems,
        this.oRegistro
      );

      if (oValidacion.bError) {
        this.oModalMensaje.bModalVisible = !this.oModalMensaje.bModalVisible;
        this.oModalMensaje.sMensaje =
          "Se require todos los campos obligatorios diligenciados ";
        this.oModalMensaje.nTipo = 3;
        this.bCargando = false;
        this.bCargandoEstado = false;
        return;
      }

      if (this.bComponenteDinamico) {
        this.$refs["form-dinamico"].onValidarFormulario();
        if (this.$refs["form-dinamico"].aErrores.length > 0) {
          this.oModalMensaje.bModalVisible = !this.oModalMensaje.bModalVisible;
          this.oModalMensaje.sMensaje =
            "Se require todos los campos obligatorios diligenciados ";
          this.oModalMensaje.nTipo = 3;
          this.bCargando = false;
          this.bCargandoEstado = false;
          return;
        }
      }

      if (Object.prototype.hasOwnProperty.call(this.oRegistro, "sCorreos")) {
        if (
          this.oRegistro.sCorreos !== "" ||
          this.oRegistro.sCorreos !== null
        ) {
          this.oRegistro.sCorreos.split(";").forEach((item) => {
            const emailRegex =
              /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
            if (!emailRegex.test(item)) {
              this.aErrores.push("Correo " + item + " inválido");
            }
          });
          if (this.aErrores.length > 0) {
            this.bMostrarErrores = true;
            this.bCargando = false;
            this.bCargandoEstado = false;
            return;
          }
        }
      }

      if (
        Object.prototype.hasOwnProperty.call(this.oRegistro, "anexos") &&
        this.aAnexosSubir.length === 0
      ) {
        this.oRegistro.anexos.forEach((oItem) => {
          this.aAnexosSubir.push({ ...oItem });
        });
        this.oRegistro.anexos = this.onFormatearAnexos(this.oRegistro.anexos);
      }
      if (this.aAnexosSubir.length > 0) this.onSubirAnexos(this.aAnexosSubir);

      let sParams = "sTabla=" + this.sTabla;
      this.oRegistro.app = "PqrWeb";
      this.oRegistro.Fecha = jsFecha.getNow();
      this.oRegistro.idFormulario = this.sIdDinamico;
      try {
        const { nStatusCode, sMessage } = await axiosServices.postConfiguration(
          "/pqr/web",
          this.oRegistro,
          true,
          sParams
        );
        this.oModalMensaje.bModalVisible = !this.oModalMensaje.bModalVisible;
        this.oModalMensaje.sMensaje = sMessage;
        this.bCargando = false;
        if ( nStatusCode === 200 || nStatusCode === 210 ) {
          this.oModalMensaje.nTipo = 2;
          this.aAnexosSubir = [];
          this.onCancelar(sMessage);
        } else {
          this.oModalMensaje.nTipo = 3;
          this.bCargandoEstado = false;
        }
      } catch (e) {
        this.oModalMensaje.bModalVisible = !this.oModalMensaje.bModalVisible;
        this.oModalMensaje.sMensaje = "Estamos presentando problemas de red";
        this.oModalMensaje.nTipo = 3;
        this.bCargandoEstado = false;        
      }
    },
  },
  computed: {
    bComponenteDinamico() {
      return (
        this.bPermisoDinamico &&
        this.onSubTipo !== "" &&
        this.sIdDinamico !== ""
      );
    },
  },
};
</script>
  <style lang="scss" scoped>
.mdlHeadForms {
  font-size: 0.9em;
}
</style>
  